export default "__VITE_ASSET__Do5uNEJX__"